/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SaSheetStaff { 
    id?: string;
    sa_sheet_id?: string;
    staff_id?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    sa_sheet_staff_group_id?: string;
    sort_order?: number;
    leave_data_done?: boolean;
    ot_data_done?: boolean;
    working_time_data_done?: boolean;
    working_time_summary_ready?: boolean;
    working_time_summary_status?: string;
    payslip_ready?: boolean;
    working_time_summary_latest?: Date;
    payroll_done?: boolean;
    user_bank_id?: string;
}